import styles from "./ShortlistCardModals.module.scss";

const SHIMMER_CARD_COUNT = 5;

const ModalShimmer: React.FC = () => (
  <div className={styles.shimmerList}>
    {Array.from({ length: SHIMMER_CARD_COUNT }, (_, i) => (
      <div key={i} className={styles.shimmerCard} />
    ))}
  </div>
);

export default ModalShimmer;
